<template>
  <div style="text-align: left;">
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
      <van-swipe-item>
        <van-image
          width="100%"
          height="100%"
          fit="contain"
          src="/static/images/img_todo.jpg"
        />
      </van-swipe-item>
    </van-swipe>
    <van-panel title="活动任务">
      <van-list
        v-model="loading"
        :finished="finished"
        @load="onLoad"
      >
        <van-cell v-for="item in todoList" key="index">
          <van-row type="flex" align="center">
            <van-col span="3">
              <van-image
                width="80%"
                height="80%"
                fit="contain"
                src="/static/images/icon_activity_todo.png"
              />
            </van-col>
            <van-col span="17">
              <div style="font-size: 12pt;">{{item.name}}({{item.count}}/{{item.conditionCount}})</div>
              <div style="font-size: 9pt;">{{item.desc}}.</div>
            </van-col>
            <van-col span="5">
              <van-button v-if="item.giftGeted" color="#6C6C6C" size="small">已领取</van-button>
              <van-button v-else-if="item.canGet" color="#46C9BA" size="small" v-on:click="doGetGift(item.ruleId)">领取
              </van-button>
              <van-button v-else-if="!item.canGet" color="#6C6C6C" size="small">
                未达标
              </van-button>
            </van-col>
          </van-row>
        </van-cell>
      </van-list>
    </van-panel>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        todoList: [],
        loading: false,
        finished: false
      }
    },
    methods: {
      onLoad: function () {
        this.loadTodoListData()
      },
      //加载页面数据
      loadTodoListData: function () {
        let data = new FormData()
        let customerId = this.$route.query.customerId
        data.append('customerId', customerId)
        this.$axios.post('/api/activity/todo/todo-list', data).then(res => {
          if (res.data.success) {
            this.todoList = res.data.userObject
          } else {
            this.$toast.fail('加载失败，原因：' + res.data.msg + '!')
          }
          //加载状态结束
          this.finished = true
        }).catch(error => {
          this.finished = true
          this.$toast.fail('加载失败!')
        })
      },
      doGetGift: function (ruleId) {
        let data = new FormData()
        let customerId = this.$route.query.customerId
        data.append('customerId', customerId)
        data.append('ruleId', ruleId)
        this.$axios.post('/api/activity/todo/do-getgift', data).then(res => {
          if (res.data.success) {
            this.loadTodoListData()
            this.$toast.success('领取成功！')
          } else {
            this.$toast.fail('领取失败，原因：' + res.data.msg + '!')
          }
          //加载状态结束
          this.finished = true
        }).catch(error => {
          console.log(error)
          this.finished = true
          this.$toast.fail('领取失败!')
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/user/UserTodo.vue